const UserType = {
  STUDENT: {
    title: 'Student',
    value: 'student',
    icon: '/icon-people-man-graduate.svg',
  },
  TEACHER: {
    title: 'Teacher',
    value: 'teacher',
    icon: '/icon-school-teacher.svg',
  },
  PARENT: {
    title: 'Parent',
    value: 'parent_of_student',
    icon: '/icon-family-home.svg',
  },
  BOOK_CLUB_MEMBER: {
    title: 'Book Club Member',
    value: 'book_club_member',
    icon: '/icon-read-human.svg',
  },
  LIBRARIAN: {
    title: 'Librarian',
    value: 'librarian',
    icon: '/icon-read-glasses.svg',
  },
  OTHER: {
    title: 'Other',
    value: 'other',
    icon: '/icon-more.svg',
  },
}

export default UserType
